module.exports = __webpack_public_path__ + "assets/img/ExtractTen_btn.0b059130.png";